import script from "./Datajc.vue?vue&type=script&setup=true&lang=js"
export * from "./Datajc.vue?vue&type=script&setup=true&lang=js"

import "./Datajc.vue?vue&type=style&index=0&id=1387149a&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版 - 圆导航\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1387149a"]])

export default __exports__